import conf from "@/views/im/conf";
import RequestUtils from "./RequestUtils";
import store from "@/store";

class MsgUtils {
	constructor() {
	  this.instance = null;
	}

	static getInstance() {
	  if (!this.instance) {
	    this.instance = new MsgUtils();
	  }
	  return this.instance;
	}

	request(self, param) {
		if (conf.platform == 'lazada') {
			return this.RequestByLazada(self, param);
		} else if (conf.platform == 'shopee') {
			return this.RequestByShopee(self, param);
		}
	}

	translate(query, callback) {
		let param = new FormData();
	    param.set("querys", JSON.stringify([{"src": query}]));
	    param.set("to", store.state.translate);

      	RequestUtils.request(conf.translantText(), param)
      	.then(json => {        
        	callback && callback(json.trans_result[0]['dst']);
      	})
	}

	// send message by lazada
	RequestByLazada(self, param) {
		let template_id = param.get('template_id');
		let message = {};
		let temp_message_id = 'sending_'+store.state.user.id+'_'+(new Date()).getTime();

		switch(template_id) {
			case '1':
				message = {
		          message_id: temp_message_id,
		          template_id: template_id*1,
		          data: {
		            txt: param.get('txt')
		          }
		        };
		        if (param.get('trans_src')) {
		        	message.data.trans_result = {'zh': param.get('trans_src')};
		        }
			break;
			case '3':
				message = {
		          message_id: temp_message_id,
		          template_id: template_id*1,
		          data: {
		            imgUrl: param.get('img_url'),
		            width: param.get('width'),
		            height: param.get('height')
		          }
		        };
			break;
			case '4':
				message = {
		          message_id: temp_message_id,
		          template_id: template_id*1,
		          data: {
		            txt: param.get('txt'),
		            imgUrl: param.get('imgUrl'),
		            smallImgUrl: param.get('smallImgUrl')
		          }
		        };
			break;
			case '10006':
				message = {
		          message_id: temp_message_id,
		          template_id: template_id*1,
		          data: {
		            "title": param.get('title'),
		            "price": param.get('price'),
		            "oldPrice": param.get('oldPrice'),
		            "discount": param.get('discount'),
		            "iconUrl": param.get('iconUrl'),
		            "itemId": param.get('item_id'),
		            "actionUrl": param.get('actionUrl')
		          }
		        };
			break;
			case '10007':
				message = {
		          message_id: temp_message_id,
		          template_id: template_id*1,
		          data: {
		            "orderId": param.get('order_id'),
                    "iconUrl": param.get('iconUrl'),
                    "productName": param.get('productName'),
                    "status": param.get('status'),
                    "content": param.get('content'),
		          }
		        };
			break;
			case '10008':
				message = {
		          message_id: temp_message_id,
		          template_id: template_id*1,
		          data: {
		            "voucherType": param.get('voucherType'),
                    "title": param.get('title'),
                    "discountAmount": param.get('discountAmount'),
                    "currency": param.get('currency'),
                    "period": param.get('period'),
		          }
		        };
			break;
		}


		self.$store.commit("lazada/addMessage", message);
		let seller_id = self.$store.state.lazada.currentStore.seller_id;
		let that = this;
		param.set('temp_message_id', temp_message_id);

		return new Promise(resolve => {
			if (template_id === '1' && self.$store.state.sendBefore === 'translate') {
				that.translate(param.get('txt'), function (transTxt) {
					param.set('txt', transTxt);
					self.$store.commit("lazada/setMessageTxt", {temp_message_id: temp_message_id, seller_id: seller_id, transTxt: transTxt});
					RequestUtils.request(conf.sendMessage(), param)
					.then(json => {
						let message_id = json.message_id ? json.message_id : ('error_'+(new Date()).getTime());
						self.$store.commit("lazada/setMessageId", {temp_message_id: temp_message_id, message_id: message_id, seller_id: seller_id});
						resolve(json);
					})
				})
			} else {
				RequestUtils.request(conf.sendMessage(), param)
				.then(json => {
					let message_id = json.message_id ? json.message_id : ('error_'+(new Date()).getTime());
					self.$store.commit("lazada/setMessageId", {temp_message_id: temp_message_id, message_id: message_id, seller_id: seller_id});
					resolve(json);
				})
			}
		})
	}

	// send message by shopee
	RequestByShopee(self, param) {
		let message_type = param.get('message_type');
		let message = {};
		let nowTime = Math.floor((new Date()).getTime()/1000);
		let temp_message_id = 'sending_'+(new Date()).getTime();

		switch(message_type) {
			case 'text':
		        message = {
		            "message_id": temp_message_id,
		            "to_id": param.get('to_id'),
		            "message_type": "text",
		            "content": {
		                "text": param.get('text')
		            },
		            "created_timestamp": nowTime
		        };
		        if (param.get('trans_src')) {
		        	message.content.trans_result = {'zh': param.get('trans_src')};
		        }
			break;
			case 'sticker':
		        message = {
		            "message_id": temp_message_id,
		            "to_id": param.get('to_id'),
		            "message_type": "sticker",
		            "content": {
		            	sticker_id: param.get('sticker_id'),
		            	sticker_package_id: param.get('sticker_package_id')
		            },
		            "created_timestamp": nowTime
		        };
			break;
			case 'image':
		        message = {
		            "message_id": temp_message_id,
		            "to_id": param.get('to_id'),
		            "message_type": "image",
		            "content": {
		            	url: param.get('image_url'),
		            },
		            "created_timestamp": nowTime
		        };
			break;
			case 'item':
		        message = {
		            "message_id": temp_message_id,
		            "to_id": param.get('to_id'),
		            "message_type": "item",
		            "content": {
		            	item_id: param.get('item_id'),
		            	shop_id: param.get('shop_id')
		            },
		            "created_timestamp": nowTime
		        };
			break;
			
			
		}
		console.log(message);

		self.$store.commit("shopee/addMessage", message);
		let shop_id = self.$store.state.shopee.currentStore.shop_id;
		let that = this;

		return new Promise(resolve => {
			if (message_type === 'text' && self.$store.state.sendBefore === 'translate') {
				that.translate(param.get('text'), function (transTxt) {
					param.set('text', transTxt);
					self.$store.commit("shopee/setMessageTxt", {temp_message_id: temp_message_id, shop_id: shop_id, transTxt: transTxt});
					RequestUtils.request(conf.sendMessage(), param)
					.then(json => {
						let message_id = json.message_id ? json.message_id : ('error_'+(new Date()).getTime());
						self.$store.commit("shopee/setMessageId", {temp_message_id: temp_message_id, message_id: message_id, shop_id: shop_id});
						resolve(json);
					})
				})
				
			} else {
				RequestUtils.request(conf.sendMessage(), param)
				.then(json => {
					let message_id = json.message_id ? json.message_id : ('error_'+(new Date()).getTime());
					self.$store.commit("shopee/setMessageId", {temp_message_id: temp_message_id, message_id: message_id, shop_id: shop_id});
					resolve(json);
				})
			}
		})
	}
}

export default MsgUtils.getInstance();